import { FC } from 'react';
import { atom, useRecoilState } from 'recoil';

import * as K from 'common/constants';
import ELEMENT from 'common/element';

import Dialog from 'components/common/Dialog/Dialog';

import './SeeMoreDialog.scss';

export type SeeMoreState = {
  field: string;
  value: string | JSX.Element;
};

export const seeMoreStateDefault: SeeMoreState = {
  field: '',
  value: '',
};

// name and value of a facet that was too long to show in full
export const seeMoreState = atom<SeeMoreState>({
  key: K.RECOIL_ATOM_KEY.SEE_MORE,
  default: seeMoreStateDefault,
});

/**
 * This component displays content that is too large to show in its original context, eg within a log line. Instead of
 * taking props, it uses a bit of Recoil state called 'seeMoreState', which contains the name of a facet and its full value.
 */
const SeeMoreDialog: FC = () => {
  const [seeMore, setSeeMore] = useRecoilState(seeMoreState);

  return (
    <Dialog
      className="SeeMoreDialog"
      title={seeMore.field}
      show={!!seeMore.value}
      close={() => setSeeMore(seeMoreStateDefault)}
      footer={{ omit: true }}
      testId={ELEMENT.seeMoreDialog}
    >
      {seeMore.value}
    </Dialog>
  );
};

export default SeeMoreDialog;
